import { useNavigate } from "react-router-dom";
import { PageHeader, type PageHeaderProps } from "./PageHeader";
import { twMerge } from "tailwind-merge";

export interface PageBodyProps extends Pick<PageHeaderProps, "title" | "onIconClick" | "icon"> {
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
}

export const PageBody = (props: PageBodyProps) => {
  const { children, title, onIconClick, className, contentClassName, icon } = props;
  const navigate = useNavigate();

  return (
    <div className={twMerge("h-screen flex flex-col items-stretch justify-start", className)}>
      <PageHeader
        icon={icon}
        onIconClick={() => {
          if (onIconClick) {
            onIconClick();
          } else {
            navigate(-1);
          }
        }}
        title={title}
      />
      <div className={twMerge("flex-1 min-h-0", contentClassName)}>{children}</div>
    </div>
  );
};
